import React, { useState } from "react"
import { nonAuthAxios } from "api/axios-global"
import axios from "axios"
import { createContext } from "react"
import PropTypes from "prop-types"

export const authContext = createContext(null)

function AuthProvider({ children }) {
  const [userData, setUserData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const getUserProfile = async () => {
    try {
      const res = await axios.get("/users/profile/details/")
      setUserData(res)
    } catch (error) {
      // toast.error(error)
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  const getUserToken = async payload => {
    try {
      const { access } = await nonAuthAxios.post("/auth/token/", payload)
      localStorage.setItem("pixamo_token", access)
      return access
    } catch (error) {
      throw error
    }
  }

  const updateUserData = async payload => {
    setUserData({ ...userData, ...payload })
  }

  const userLogout = () => {
    localStorage.removeItem("pixamo_token")
    setUserData(null)
  }

  return (
    <authContext.Provider
      value={{
        userData,
        isLoading,
        error,
        getUserProfile,
        getUserToken,
        userLogout,
        updateUserData,
      }}
    >
      {children}
    </authContext.Provider>
  )
}
authContext.propTypes = {
  children: PropTypes.element,
}
export default AuthProvider
